import { SelectedWidgetType } from './StatChartWidgetToolbar.types';

/**
 * Determines the type of the statchart widget members is selected (chart, icon, label)
 *
 * @param {boolean} isChartWidgetSelected
 * @param {boolean} isIconWidgetSelected
 * @param {boolean} isLabelTextWidgetSelected
 * @returns {SelectedWidgetType | ('Chart' | 'Icon' | 'Label' | undefined)}
 */
export const getSelectedWidgetType = ({
  isChartWidgetSelected,
  isIconWidgetSelected,
  isLabelTextWidgetSelected,
}: {
  isChartWidgetSelected: boolean;
  isIconWidgetSelected: boolean;
  isLabelTextWidgetSelected: boolean;
}) => {
  let selectedWidgetType: SelectedWidgetType | undefined;
  if (isChartWidgetSelected) selectedWidgetType = 'Chart';
  if (isIconWidgetSelected) selectedWidgetType = 'Icon';
  if (isLabelTextWidgetSelected) selectedWidgetType = 'Label';

  return selectedWidgetType;
};
